import { Routes } from "@angular/router";
import { AuthLayout } from "./@features/layouts/auth-layout/auth-layout";

export const routes: Routes = [
  /** Default entry — send users to login under `/auth/login`. */
  {
    path: "",
    redirectTo: "auth/login",
    pathMatch: "full",
  },
  {
    path: "auth",
    component: AuthLayout,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./@features/auth/auth.routes").then((m) => m.AuthPageRouting),
      },
    ],
  },
  {
    path: "",
    loadComponent: () => import("./@features/layouts/app-layout/app-layout").then((m) => m.AppLayout),
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./@features/features.routes").then((m) => m.featuresRoutes),
      },
    ],
  },
];
